import { Component, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { Session } from '../../../../../../interfaces/session-data';
import { SessionService } from '../../../../../../services/session/session.service';
import { takeUntil } from 'rxjs/operators';
import { CardSchema } from '../../../../../../interfaces/card/CardSchema';

@Component({
  selector: 'app-debit-credit-card-payment-method',
  templateUrl: './debit-credit-card.component.html',
  styleUrls: ['./debit-credit-card.component.scss']
})
export class DebitCreditCardComponent implements OnInit, OnDestroy {
  public link:string;
  public cardSchemas:CardSchema[];
  private lock: boolean = false;
    private session:Session;
    private destroy$ = new Subject<void>();
  constructor(
    private router:Router,
    private sessionService:SessionService,
    private route: ActivatedRoute
  ) {
    this.cardSchemas = [];
    this.link = "card/add";
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.session = sessionStorage.getItem("sessionData")? JSON.parse(sessionStorage.getItem("sessionData")) : null;
    this.selectMethod();
    this.sessionService.getPaymentMethodListLock().pipe(takeUntil(this.destroy$)).subscribe((lock:boolean) => {
      this.lock = lock;
    });
    this.sessionService.getSupportedCardSchema().pipe(takeUntil(this.destroy$)).subscribe((cardSchemas:CardSchema[]) => this.cardSchemas = cardSchemas);
  }

  toggleListView(){
    this.sessionService.emitPaymentMethodPromotion("debit-credit-card");
  }

  selectMethod(event?: Event){
    sessionStorage.setItem("selected-payment","card");
    if(event!=undefined &&!this.lock){
      this.sessionService.setCurrencyCodeListLock(false);
      this.sessionService.emitSelectedPaymentMethod("debit-credit-card");
      this.router.navigate([this.link],{relativeTo: this.route});
    }
  }

}
